export default __webpack_public_path__ + "static/media/spf_5035_49556006477_o.fd4156ae.jpg";